/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_Domain_SupplierInputs */

const en_mapping_domain_supplier = /** @type {(inputs: Mapping_Domain_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppliers`)
};

/**
* | output |
* | --- |
* | "Suppliers" |
*
* @param {Mapping_Domain_SupplierInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_domain_supplier = /** @type {((inputs?: Mapping_Domain_SupplierInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_Domain_SupplierInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_domain_supplier(inputs)
});